import { render, staticRenderFns } from "./TextValueChange.vue?vue&type=template&id=500125ae&"
import script from "./TextValueChange.vue?vue&type=script&lang=js&"
export * from "./TextValueChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports